module.exports = __webpack_public_path__ + "img/title.ef44781d.png";